interface CurrencyFormatProps {
  className?: string;
  value: number;
  currency?: string;
  decimalAmount?: number;
  sameColor?: boolean;
  nation?: ',' | '.';
  postfix?: string;
}

export const CurrencyFormat: React.FC<CurrencyFormatProps> = ({
  className,
  value,
  currency = '$',
  decimalAmount = 2,
  sameColor = false,
  nation = ',',
  postfix = '',
}) => {
  // `toFixed` throws a RangeError outside 0-100 digits, and NaN/Infinity would
  // leak into the output, so normalize both inputs before formatting.
  const safeDecimals = Number.isFinite(decimalAmount)
    ? Math.min(Math.max(Math.trunc(decimalAmount), 0), 20)
    : 2;
  const safeValue = Number.isFinite(value) ? value : 0;

  // Truncate decimals without rounding up
  const multiplier = Math.pow(10, safeDecimals);
  const scaled = Math.floor(safeValue * multiplier) / multiplier;
  const truncatedValue = Number.isFinite(scaled) ? scaled : safeValue;

  const parts = truncatedValue.toFixed(safeDecimals).toString().split('.');
  const thousandsSeparator = nation === ',' ? '.' : ',';
  const integerPart = parts[0].replace(
    /\B(?=(\d{3})+(?!\d))/g,
    thousandsSeparator,
  );
  const decimalPart = parts[1]?.replace(/0+$/, ''); // Remove trailing zeros

  return (
    <div className={className || ''}>
      {currency}
      {integerPart}
      {safeDecimals !== 0 && decimalPart && (
        <span
          className={`${sameColor ? '' : 'text-t-tertiary'}`}
        >{`${nation}${decimalPart}`}</span>
      )}
      {` ${postfix}`}
    </div>
  );
};
